<template>
    <!-- <v-card
    class="mx-auto overflow-hidden mg"
    height="400"
    width="344"
  > -->

    <v-navigation-drawer v-if="videos && videos.length" v-model="slide" fixed right temporary>
        <div class="how-to-guid">HOW TO GUIDE</div>
		 <div class="floating-video-close otp-cross">
                    <v-icon @click="onClose()">mdi-close</v-icon>
                </div>
        <div class="video-scroll">
            <div class="video-panel-slide" v-for="vl in videos" :key="vl.id">
                <div class="how-to-guid">{{ vl.group_name }}</div>
                <div
                    class="video-panel-slide"
                    v-for="v in vl.videos"
                    :key="v.id"
                >
                    <v-row @click="onClose(v.video_id)">
                        <v-col cols="6" class="padding-new-top">
                            <img
                                class="video-thumb"
                                :src="
                                    'http://img.youtube.com/vi/' +
                                        v.video_id +
                                        '/0.jpg'
                                "
                            />
                        </v-col>
                        <v-col cols="6" class="padding-new-top padding-left-0">
                            <label class="video-name">{{
                                v.title.length < 99
                                    ? v.title
                                    : v.title.substring(0, 100) + "..."
                            }}</label>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </v-navigation-drawer>
    <!-- </v-card> -->
</template>

<script>
// Utilities
import { mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
    name: "VideoSlidePanel",
    props: ["drawer", "close"],
    data() {
        return {
            slide: false,
            items: [
                { title: "Home", icon: "mdi-home-city" },
                { title: "My Account", icon: "mdi-account" },
                { title: "Users", icon: "mdi-account-group-outline" },
            ],
            mini: true,
            videos: [],
        };
    },

    computed: {
        ...mapState("app", ["color", "image", "selectedMenu"]),
        ...mapState("userStore", ["user", "myInstitute"]),
        ...mapState("testStore", ["isTestStarted"]),

        inputValue: {
            get() {
                return this.$store.state.app.drawer;
            },
            set(val) {
                this.setDrawer(val);
            },
        },
    },

    mounted() {},
    beforeDestroy() {},

    methods: {
        setSlide(slide) {
            this.slide = slide;
        },
        onClose(vid) {
			if (vid) {
				this.close(false, vid);
			}
            this.slide = false;
        }
    },
    watch: {
        drawer(val) {
            if (val) {
                this.setSlide(val);
                // this.videos=this.user.videos;
                let videos = _.mapValues(
                    _.groupBy(this.user.videos, "group_name")
                );
				this.videos =[];
                for (const [key, value] of Object.entries(videos)) {
                    this.videos.push({
                        group_name: key,
                        videos: value,
                    });
                }
            }
        },
        slide(val) {
            if (!val) {
                this.close(val);
            }
        },
    },
};
</script>

<style lang="scss">
#app-drawer {
    .v-list__tile {
        border-radius: 4px;
        &--buy {
            margin-top: auto;
            margin-bottom: 17px;
        }
    }
    // .v-image__image--contain {
    //     top: 6px;
    //     height: 80%;
    // }
    .search-input {
        margin-bottom: 30px !important;
        padding-left: 15px;
        padding-right: 15px;
    }
}
</style>
